import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { getCustomers } from "../../actions/user.action";
import AlertConfirm from "../../components/alertConfirm.component";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CustomTable from "../../components/Table/CustomTable.component";
import SwitchForm from "../../components/Switch/switchForm.component";
import { isEmpty, isEqual } from "../../utils/proprietaryHooks";
import { SET_CUSTOMERS_ERROR, SET_PENDING_CHANGE_ASSIGNED } from "../../actions/types";

/**
 * UserCustomer Component ( view customer from a user )
 *
 * @export Class Component
 * @class UserCustomer
 * @extends {Component}
 * @returns Redux connect
 */

const useStyles = makeStyles((theme) => ({
  card: {

  },
  filter: {
    // paddingLeft: "23px",
  },
  searchTextField: {
    width: "468px",
    maxHeight: "25px",
    paddingLeft: "23px",
  },
  tableCellHeader: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    padding: 2,
    "&:nth-child(1)": {
      borderRadius: "5px 0px 0px 5px",
    },
    "&:nth-last-child(1)": {
      borderRadius: "0px 5px 5px 0px",
    },
  },
  tableCellBody: { padding: "12px" },
}));

const UserCustomer = forwardRef((props, ref) => {
  const classes = useStyles();
  const { customers, setCustomers } = props;
  const {
    userId,
    setErrorsCustomer,
    getCustomers,
    getCustomersResponse,
    getCustomersResponseAux,
    rows,
    setEditedCustomers,
    setLoading,
    isEnabled,
    customersErrors,
    customersAux,
    setCustomersAux,
    setEditedCustomersAux,
  } = props;
  const [confirmPrincipal, setConfirmPrincipal] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [isSearch, setIsSearch] = useState();
  const [checked, setChecked] = useState({
    index: "",
    name: "",
    checked: false,
    id: "",
  });
  const [option, setOption] = useState(null);
  const allCustomersRef = React.useRef([]);
  const principalIdRef = React.useRef(null);
  const dispatch = useDispatch();
  const principalSwapRef = React.useRef({ prevId: null, newId: null });
  const assignedSwapRef = React.useRef({ id: null, value: null });
  useImperativeHandle(ref, () => ({
    getPrincipalSwap: () => principalSwapRef.current,
    getAssignedSwap: () => assignedSwapRef.current,
    getAllCustomers: () => allCustomersRef.current,
    clearPrincipalSwap: () => { principalSwapRef.current = { prevId: null, newId: null }; },
    clearAssignedSwap: () => { assignedSwapRef.current = { id: null, value: null }; },
    getCustomerById: (id) => allCustomersRef.current.find(c => Number(c.id) === Number(id)),
    clearFromParent: () => { handleClearFromParent(); },
  }));
  const tableRef = React.useRef(null);

  const columns = [
    {
      id: "name",
      label: "Empresa",
      minWidth: 280,
      align: "left",
      haveDropDown: true,
      key: " ",
    },
    {
      id: "principal",
      label: "Empresa principal",
      minWidth: 90,
      align: "center",
      haveDropDown: true,
      withIcon: false,
      tooltipMessage: "principal",
      format: (value) => value,
      children: (value, row) => {
        return switchComponent(value, row, "principal");
      },
    },
    {
      id: "assigned",
      label: "Asignado",
      minWidth: 20,
      format: (value) => value,
      haveDropDown: true,
      tooltipMessage: "Asignado",
      children: (value, row) => {
        return switchComponent(value, row, "assigned");
      },
    },
  ];

  const switchComponent = (value, row, id) => {
    return (
      <Grid container direction="row" alignItems={"center"} justifyContent={"center"}>
        <div>
          <SwitchForm
            checked={id === "assigned" && row.principal === true ? false : value}
            name={id}
            disabled={!isEnabled}
            onChange={(e) => {
              handleConfirmCustomer(e, row.id, id);
            }}
          />
        </div>
      </Grid>
    );
  };

  const handleConfirmCustomer = (event, id, eventName) => {
    setChecked({
      name: eventName,
      checked: event.target.checked,
      id,
    });
    if (event.target.checked === true && eventName === "principal") {
      const currentPrincipalId = principalIdRef.current;
      if (currentPrincipalId) {
        setErrorsCustomer(false);
        setConfirmPrincipal(true);
      } else {
        handleChangeCheckedCustomer(id, eventName);
      }
    } else {
      handleChangeCheckedCustomer(id, eventName);
    }
  };

  const pendingChangesArray = useSelector(({ userReducer }) => {
    return userReducer.setPendingChangeAssigned;
  });

  const handleChangeCheckedCustomer = (eventId, eventName) => {
    let name = eventName ?? checked.name;
    let id = Number(eventId ?? checked.id);
    if (name === "principal") {
      setErrorsCustomer(false);
      const newId = Number(id);
      const currentPrincipal = customers.find(c => c.principal === true);
      const prevId = currentPrincipal ? Number(currentPrincipal.id) : null;

      if (prevId === newId) return;

      principalSwapRef.current = { prevId, newId };

      const applyPrincipal = (list) =>
        list.map((item) => {
          const itemId = Number(item.id);
          const isNewPrincipal = itemId === newId;
          const isPrevPrincipal = prevId != null && itemId === prevId;

          if (isNewPrincipal) {
            return { ...item, principal: true, assigned: true };
          }

          if (isPrevPrincipal) {
            return { ...item, principal: false, assigned: false };
          }
          const wasAssignedInReducer = pendingChangesArray.find(
            (p) => Number(p.id) === itemId
          );

          return {
            ...item,
            principal: false,
            assigned: wasAssignedInReducer ? wasAssignedInReducer.assigned : item.assigned,
          };
        });
      const updatedFullList = applyPrincipal(customersAux);

      const newPending = updatedFullList.filter(item => {
        const original = customersAux.find(orig => Number(orig.id) === Number(item.id));
        return !isEqual(item, original);
      });

      dispatch({ type: SET_PENDING_CHANGE_ASSIGNED, payload: newPending });

      setCustomers((prev) => applyPrincipal(prev));

      allCustomersRef.current = applyPrincipal(allCustomersRef.current);
      principalIdRef.current = newId;
      setConfirmPrincipal(false);
      return;
    }

    if (name === "assigned") {
      const current = customers.find(c => Number(c.id) === Number(id));
      if (!current || current.principal) return;

      const newValue = !current.assigned;
      const updatedItem = { ...current, assigned: newValue };
      const originalItem = customersAux.find(c => Number(c.id) === Number(id));

      let newPendingArray = [...pendingChangesArray];
      const isBackToOriginal = originalItem && originalItem.assigned === newValue && originalItem.principal === current.principal;

      if (isBackToOriginal) {
        newPendingArray = newPendingArray.filter(item => Number(item.id) !== Number(id));
      } else {
        const exists = newPendingArray.some(item => Number(item.id) === Number(id));
        if (exists) {
          newPendingArray = newPendingArray.map(item =>
            Number(item.id) === Number(id) ? updatedItem : item
          );
        } else {
          newPendingArray.push(updatedItem);
        }
      }
      dispatch({ type: SET_PENDING_CHANGE_ASSIGNED, payload: newPendingArray });
      setCustomers(prev => prev.map(item => Number(item.id) === id ? updatedItem : item));
      setConfirmPrincipal(false);
      return;
    }
  };


  const sortBy = React.useMemo(
    () => [
      { prop: "principal", direction: -1 },
      { prop: "assigned", direction: -1 },
    ],
    []
  );

  const compareCustomers = useCallback((a, b) => {
    let i = 0, result = 0;
    while (i < sortBy.length && result === 0) {
      result =
        sortBy[i].direction *
        (a[sortBy[i].prop] < b[sortBy[i].prop]
          ? -1
          : a[sortBy[i].prop] > b[sortBy[i].prop]
            ? 1
            : 0);
      i++;
    }
    return result;
  }, [sortBy]);

  const sortData = useCallback((data) => {
    const copy = [...data];
    copy.sort((a, b) => (a.name === b.name ? 0 : a.name > b.name ? 1 : -1));
    copy.sort((a, b) => compareCustomers(a, b));
    return copy;
  }, [compareCustomers]);

  const handleSearchUsers = useCallback((name) => {
    const term = (name ?? "").trim();
    setIsSearch(term);
    if (term !== "") {
      setLoadingSearch(true);
    }
    getCustomers(userId, term, 0);
  }, [getCustomers, userId, setLoadingSearch, setIsSearch]);

  const handleClearFromParent = useCallback(() => {
    handleSearchUsers("");
    tableRef.current?.clearSearch();
  }, [handleSearchUsers]);


  useEffect(() => {
    if (!isEmpty(getCustomersResponse)) {
      const sorted = sortData(getCustomersResponse);
      const projectedData = sorted.map(originalItem => {
        const change = pendingChangesArray.find(p => Number(p.id) === Number(originalItem.id));
        return change ? { ...originalItem, ...change } : originalItem;
      });
      if (typeof isSearch === "string" && isSearch.trim() !== "") {
        setCustomers(projectedData);
        setEditedCustomers(projectedData);
        return;
      }
      const principalCustomer = projectedData.find(c => c.principal === true);
      if (principalCustomer) principalIdRef.current = principalCustomer;
      allCustomersRef.current = sorted;
      setCustomers(projectedData);
      setEditedCustomers(projectedData);
    } else {
      setCustomers([]);
    }
  }, [getCustomersResponse, isSearch, sortData, setCustomers, setEditedCustomers, pendingChangesArray]);

  useEffect(() => {
    if (!isEmpty(getCustomersResponseAux)) {
      const sorted = sortData(getCustomersResponseAux);
      if (typeof isSearch === "string" && isSearch.trim() !== "") {
        const sorted = sortData(getCustomersResponseAux);
        setCustomersAux(sorted);
        setEditedCustomersAux(sorted);
        return;
      }
      const principalCustomer = sorted.find(c => c.principal === true);
      if (principalCustomer) principalIdRef.current = principalCustomer;
      allCustomersRef.current = sorted;
      setCustomersAux(sorted);
      setEditedCustomersAux(sorted);
    } else {
      setCustomersAux([]);
    }
  }, [getCustomersResponseAux, isSearch, sortData, setCustomersAux, setEditedCustomersAux]);

  useEffect(() => {
    setLoading(false);
    setLoadingSearch(false);
  }, [getCustomersResponse, setLoading]);

  const handleChangePages = (_event, newPage, rowsPerPage, search) => {
    const numRows = rowsPerPage;
    let last;
    if (search === '') {
      last = customers.length;
      if (!isSearch && last < (newPage + 1) * numRows) {
        getCustomers(userId, '', last);
      }
    }
  };


  useEffect(() => {
    if (!isEmpty(customersErrors)) {
      setErrorsCustomer(customersErrors?.result?.information || "Ocurrió un error al obtener los clientes.");
      dispatch({
        type: SET_CUSTOMERS_ERROR,
        payload: {},
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersErrors, setErrorsCustomer]);

  const getButtons = () => {
    let button = {
      justify: "space-between",
      searchBar: {
        cellSize: {
          lg: 7,
          md: 8,
          sm: 2,
        },
      },
    };
    if (!!userId) {
      button = {
        ...button,
        menuOrder: {
          cellSize: {
            lg: 6,
            md: 2,
            sm: 2,
          },
          justify: "center",
          options: [
            {
              label: "Activos",
              columns: [
                {
                  prop: "principal",
                  direction: -1,
                },
                {
                  prop: "assigned",
                  direction: -1,
                },
              ],
            },
            {
              label: "Inactivos",
              columns: [
                {
                  prop: "principal",
                  direction: 1,
                },
                {
                  prop: "assigned",
                  direction: 1,
                },
              ],
            },
            {
              label: "Modificados recientemente",
              columns: [
                {
                  prop: "modifiedOn",
                  direction: 1,
                  format: (date) => {
                    return new Date(date).getTime();
                  },
                },
              ],
            },
          ],
        },
      };
    }

    return button;
  };

  return (
    <Grid item lg={12} md={12} sm={12}>
      <Card className={classes.card}>
        <CustomTable
          ref={tableRef}
          data={customers}
          rows={rows}
          columns={columns}
          mainParam={"name"}
          havePagination={true}
          isUser={true}
          searchButton={true}
          isToolTipCustom={true}
          loading={loadingSearch}
          buttons={getButtons()}
          option={option}
          setOption={setOption}
          globalDisabled={!isEnabled}
          handleChangePages={handleChangePages}
          handleSearchUsers={handleSearchUsers}
        />
      </Card>

      {confirmPrincipal && (
        <AlertConfirm
          isOpen={confirmPrincipal}
          modalMessage={`¿Desea cambiar la empresa principal?`}
          handleAccept={() => {
            handleChangeCheckedCustomer(checked.id, checked.name);
          }}
          showBtnAccept={true}
          showBtnCancel={true}
          onCancel={true}
          onClose={() => setConfirmPrincipal(false)}
        />
      )}
    </Grid>
  );
});

UserCustomer.propTypes = {
  getCustomers: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  getCustomersResponse: state.userReducer.getCustomersResponse,
  getCustomersResponseAux: state.userReducer.getCustomersResponseAux,
  rows: state.userReducer.rows,
  customersErrors: state.userReducer.customersErrors,
});

const mapDispatchToProps = {
  getCustomers,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(UserCustomer);
